import Banner, { BannerElement } from "@/components/Banner/Banner";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { MotifIcon, MotifProgressLoader } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import TabPanel from "@/components/TabPanel/TabPanel";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetDistributionSummaryByIdQuery } from "@/services/distribution/distributionReducers";
import Summary from "./Summary";
import DistributionSteps from "../steps/DistributionSteps";
import { useCase } from "@/features/case/use-case";
import { useEffect, useState } from "react";
import DistributionContext from "./DistributionContext";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { getStatusDescription } from "@/utility/common";
import { ActiveTabsOrder } from "@/menuData";
import { setRetainDistributionId } from "@/features/retain_state/retainStateSlice";
const DistributionSummary = () => {
  const { distributionId, caseId } = useParams();
  const caseData = useCase();
  const [editDistribution, setEditDistribution] = useState(false);
  const [showDiscardPopup, setShowDiscardPopup] = useState(false);
  let discardDetails = useSelector((e: any) => e.discardChangesDatas.data);
  const [searchParams] = useSearchParams();
  const navigatedFrom = searchParams.get("navigatedFrom");
  const dispatch = useDispatch();
  function handleClose() {
    setEditDistribution(false);
    setShowDiscardPopup(false);
  }
  function handleReject() {
    setShowDiscardPopup(false);
  }
  useEffect(() => {
    dispatch(setRetainDistributionId({ distributionId: distributionId }));
  }, [dispatch, distributionId]);

  const { data, isLoading } = useGetDistributionSummaryByIdQuery({
    id: distributionId,
  });
  let distributionContextJson = {
    editDistribution: editDistribution,
    setEditDistribution: (flag: boolean) => {
      setEditDistribution(flag);
    },
    distributionName: data?.name,
    distributionStatus: data?.distributionStatus,
  };
  const breadcrumbItems = [
    {
      label: "Back",
      elementKey: "Back",
      text: caseData?.caseName,
      url: `/case/${caseId}/?activeTab=${
        navigatedFrom === "paymentGrid"
          ? ActiveTabsOrder.PAYMENT
          : ActiveTabsOrder.DISTRIBUTION
      }`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      blockNavigation: editDistribution,
    },
    {
      label: "Back",
      elementKey: "Back",
      text: data?.name,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled: true,
    },
  ];
  const creditorBanner = {
    creditorTtl: "pages.distributions.distribution.distrbutionBanner.title",
    creditorName: data?.name,
  };
  const bannerElements: BannerElement[] = [
    {
      label:
        "pages.distributions.distribution.distrbutionBanner.distributionDate",
      value: data?.distributionDate,
    },
    {
      label: "pages.distributions.distribution.distrbutionBanner.status",
      value: getStatusDescription(data?.distributionStatus),
    },
    {
      label: "pages.distributions.distribution.distrbutionBanner.effectiveDate",
      value: data?.effectiveDate ? data?.effectiveDate : "-",
    },
  ];

  const tabPanelData = {
    title: [
      "pages.distributions.distribution.tabPannelDetails.tab1",
      "pages.distributions.distribution.tabPannelDetails.tab2",
    ],
    content: [
      <div>
        <Summary />
      </div>,
      <div>
        <DistributionSteps />
      </div>,
    ],
  };
  return (
    <>
      <div
        onClick={() => {
          if (discardDetails.editMode) {
            setShowDiscardPopup(true);
          } else {
            setEditDistribution(false);
          }
        }}
      >
        {isLoading ? (
          <MotifProgressLoader
            size="xs"
            variant="default"
          ></MotifProgressLoader>
        ) : (
          <Breadcrumb
            items={breadcrumbItems}
            ariaLabel="Breadcrumb navigation"
          />
        )}
      </div>
      <Banner
        bannerName={creditorBanner.creditorTtl}
        bannerNameValue={creditorBanner.creditorName}
        elements={bannerElements}
      />
      <div className="ccwp_table_tabpanel ccwp_claim_summary_view">
        <DistributionContext.Provider value={distributionContextJson}>
          <TabPanel
            data={tabPanelData}
            defaultActiveKey={0}
            searchParams={
              navigatedFrom ? "&navigatedFrom=paymentGrid" : undefined
            }
          />
        </DistributionContext.Provider>
      </div>
      <ConfirmationModal
        isVisible={showDiscardPopup}
        setIsVisible={handleClose}
        cancelBtnApproveHandler={handleClose}
        cancelBtnRejectHandler={handleReject}
      />
    </>
  );
};

export default DistributionSummary;
